import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE';

export const CHART_REVIEW_QUEUE_REPORT_REQUEST = 'CHART_REVIEW_QUEUE_REPORT_REQUEST';
export const CHART_REVIEW_QUEUE_REPORT_SUCCESS = 'CHART_REVIEW_QUEUE_REPORT_SUCCESS';
export const CHART_REVIEW_QUEUE_REPORT_FAILURE = 'CHART_REVIEW_QUEUE_REPORT_FAILURE';

export const DASHBOARD_LOCATIONS_REQUEST = 'DASHBOARD_LOCATIONS_REQUEST';
export const DASHBOARD_LOCATIONS_SUCCESS = 'DASHBOARD_LOCATIONS_SUCCESS';
export const DASHBOARD_LOCATIONS_FAILURE = 'DASHBOARD_LOCATIONS_FAILURE';

export const DASHBOARD_CLIENTS_REQUEST = 'DASHBOARD_CLIENTS_REQUEST';
export const DASHBOARD_CLIENTS_SUCCESS = 'DASHBOARD_CLIENTS_SUCCESS';
export const DASHBOARD_CLIENTS_FAILURE = 'DASHBOARD_CLIENTS_FAILURE';

export function requestDashboardInfo(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/dashboard-info?${query}`,
      method: 'GET',
      types: ['DASHBOARD_REQUEST', 'DASHBOARD_SUCCESS', 'DASHBOARD_FAILURE']
    }
  };
}

export function requestChartReviewQueueReport(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/chat-review-queue-report?${query}`,
      method: 'GET',
      types: ['CHART_REVIEW_QUEUE_REPORT_REQUEST', 'CHART_REVIEW_QUEUE_REPORT_SUCCESS', 'CHART_REVIEW_QUEUE_REPORT_FAILURE']
    }
  };
}

export function requestClinicLocations(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/dashboard-clinic-locations?${query}`,
      method: 'GET',
      types: ['DASHBOARD_LOCATIONS_REQUEST', 'DASHBOARD_LOCATIONS_SUCCESS', 'DASHBOARD_LOCATIONS_FAILURE']
    }
  };
}

export function requestClientLocations(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/dashboard-client-locations?${query}`,
      method: 'GET',
      types: ['DASHBOARD_CLIENTS_REQUEST', 'DASHBOARD_CLIENTS_SUCCESS', 'DASHBOARD_CLIENTS_FAILURE']
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/dashboard/DashboardActions.js